export default "__VITE_ASSET__Bd__e$ge__"